```vue
<template>
  <section ref="sectionRef" class="invitation-collage-container">
    
 
    <!-- 4. MAIN CARD (DRESS CODE IN THE FOREGROUND) -->
    <div ref="mainCard" class="layer main-card-wrapper">
      <div class="dc-card">
        
        <!-- Two-line title -->
        <h2 ref="title" class="dc-title"><br />
          <span>Dress</span><br />
          <span class="script">Code</span>
        </h2>

        <!-- Badge -->
        <div ref="badge" class="dc-badge"> FORMAL</div>

        <!-- Dress / suit illustration -->
        <img
          ref="figure"
          src="@/assets/codigo.png"
          alt="Dress code"
          class="dc-figure"
        />

        <!-- Note about the reserved color -->
        <p ref="note" class="dc-note">
          Green shades are <br> reserved <br> exclusively <br>for the quinceañera.<br> Please avoid Gold and Black tones.<br><br>
        </p>

      </div>
    </div>

  </section>
</template>
```

<script>
import { ref, onMounted, nextTick, onUnmounted } from 'vue'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'DressCodeCollage',
  setup() {
    const sectionRef = ref(null)
    const topFlowers = ref(null)
    const musicDisc = ref(null)
    const photoCard = ref(null)
    const mainCard = ref(null)
    const title = ref(null)
    const badge = ref(null)
    const figure = ref(null)
    const note = ref(null)

    let ctx

    onMounted(async () => {
      await nextTick()
      if (!sectionRef.value) return

      ctx = gsap.context(() => {
        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: sectionRef.value,
            start: 'top 85%',
            end: 'bottom 30%',
            scrub: 0.6,
            invalidateOnRefresh: true
          }
        })

        /* ANIMACIONES SECUENCIALES DEL COLLAGE LIGADAS AL SCROLL */
        tl.from(topFlowers.value, {
          opacity: 0,
          y: -30,
          duration: 1,
          ease: 'power3.out'
        })
        .from(musicDisc.value, {
          opacity: 0,
          x: -30,
          rotation: -20,
          duration: 1,
          ease: 'back.out(1.2)'
        }, '-=0.5')
        .from(photoCard.value, {
          opacity: 0,
          x: 30,
          rotation: 12,
          duration: 1,
          ease: 'power3.out'
        }, '-=0.7')
        .from(mainCard.value, {
          opacity: 0,
          y: 40,
          scale: 0.9,
          duration: 1.2,
          ease: 'back.out(1.4)'
        }, '-=0.8')

        /* ANIMACIÓN DEL CONTENIDO INTERNO */
        .from(title.value, {
          opacity: 0,
          y: -15,
          filter: 'blur(4px)',
          duration: 0.8,
          ease: 'power2.out'
        }, '-=0.6')
        .from([badge.value, figure.value], {
          opacity: 0,
          scale: 0.8,
          duration: 0.8,
          stagger: 0.15,
          ease: 'back.out(1.5)'
        }, '-=0.4')
        .from(note.value, {
          opacity: 0,
          y: 15,
          duration: 0.8,
          ease: 'power2.out'
        }, '-=0.4')
      }, sectionRef.value)

      setTimeout(() => {
        ScrollTrigger.refresh()
      }, 200)
    })

    onUnmounted(() => {
      if (ctx) ctx.revert()
    })

    return {
      sectionRef,
      topFlowers,
      musicDisc,
      photoCard,
      mainCard,
      title,
      badge,
      figure,
      note
    }
  }
}
</script>

<style scoped>
/* CONTENEDOR PRINCIPAL FLUIDO */
.invitation-collage-container {
  position: relative;
  width: 100%;
  max-width: 480px;
  margin: 0 auto 40px;   background: radial-gradient(circle, #024351 0%, #012d2b 100%);


  padding-top: 10px;
  overflow: visible;
  box-sizing: border-box;
}

.img-fluid {
  width: 100%;
  height: auto;
  display: block;
}

.text {
  width: 100%;
    font-family: 'CynthiaJuneJF', cursive;

  height: auto;
  display: block;
}


.layer {
  position: relative;
}

/* 1. FLOR Y SOBRE EN LA PARTE SUPERIOR */
.top-flowers-wrapper {
  width: 85%;
  margin: 0 auto;
  z-index: 1;
}

/* 2. VINILO / CORONA (IZQUIERDA) Y 3. FOTO QUINCEAÑERA (DERECHA SUPERPUESTOS) */
.music-disc-wrapper {
  position: absolute;
  top: clamp(280px, 45vw, 420px);
  left: 20%;
  width: clamp(220px, 35vw, 180px);
  z-index: 12;
}

.photo-card-wrapper {
  position: absolute;
  top: clamp(100px, 20vw, 180px);
  right: 0%;
  width: clamp(380px, 75vw, 420px);
  z-index: 3;
}

.photo-img {
  border-radius: 14px;
}

/* 4. TARJETA PRINCIPAL (UBICACIÓN RELATIVA FLUIDA) */
.main-card-wrapper {
  position: relative;
  width: 90%;
  margin: clamp(60px, 30vw, 240px) auto 0;
  z-index: 4;
  background: url('@/assets/1a9f560911e95b82d1484f6ad0be27d4.png') no-repeat center center;
  background-size: 100% 100%;
  padding: clamp(40px, 10vw, 60px) 20px;
  box-sizing: border-box;
}

.dc-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  color: #430808;
}

/* TÍTULOS Y FUENTES ADAPTATIVAS CON CLAMP */
.dc-title {
  font-family: 'Playfair Display', serif;
  font-size: clamp(1.2rem, 5vw, 1.5rem) !important;
  line-height: 1.15;
  margin: 0 0 10px;
  color: #500909;
}

.dc-title .script {
  font-family: 'ludovica', 'Great Vibes', cursive;
  font-size: clamp(2.2rem, 10vw, 3.2rem) !important;
  font-weight: normal;
}

/* BADGE FORMAL */
.dc-badge {
  display: inline-block;
  background: linear-gradient(135deg, #d4af37 0%, #fff3a8 50%, #aa7c11 100%);
  color: #333333;
  font-family: 'Playfair Display', serif;
  font-weight: 800;
  font-size: clamp(0.75rem, 3vw, 0.85rem);
  letter-spacing: 0.15em;
  padding: 6px 20px;
  border-radius: 25px;
  margin: 10px 0 14px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.25);
}

/* ILUSTRACIÓN DE VESTIMENTA */
.dc-figure {
  width: 85%;
  max-width: 180px;
  height: auto;
  margin: 10px 0;
}

/* NOTA SOBRE EL COLOR RESERVADO */
.dc-note {
  font-family: 'Playfair Display', serif;
  font-size: clamp(1.0rem, 3.5vw, 1.0rem) !important;
  line-height: 1.2;
  margin: 10px 0 0;
  margin-top:0px;
  margin-bottom: 30px;
  padding: 0 6px;
  color: rgba(16, 2, 2, 0.98);
  font-weight: 500;
}
</style>